import type { ComponentProps } from 'react';

import { Button, type ButtonProps } from '@/components/buttons';
import { cn } from '@/lib/utils';

export type PaginationLinkProps = Omit<ComponentProps<'a'>, 'disabled'> & {
  isActive?: boolean;
  size?: ButtonProps['size'];
  disabled?: ButtonProps['disabled'];
};

const PaginationLink = ({
  className,
  children,
  isActive,
  size = 'icon',
  disabled,
  ...anchorProps
}: PaginationLinkProps) => {
  return (
    <Button
      variant={isActive ? 'primary' : 'ghost'}
      shape="square"
      size={size}
      disabled={disabled}
      className={cn(className)}
      nativeButton={false}
      render={
        <a
          aria-current={isActive ? 'page' : undefined}
          data-slot="pagination-link"
          data-active={isActive ? 'true' : undefined}
          {...anchorProps}
        />
      }
    >
      {children}
    </Button>
  );
};

export default PaginationLink;
